import { ICopyable, IJsonSerializable } from '../util/interfaces'

import { OpDataList } from '../util/op-data-list'

import { OpTariffData } from '../core/op-tariff-data'

export class OpTariffScheme implements IJsonSerializable, ICopyable<OpTariffScheme> {

    // #region Properties

    public idTariff: number
    public tariffOptionsData: OpDataList<OpTariffData> = new OpDataList<OpTariffData>()

    // #endregion


    // #region Ctor

    constructor(opObj: any = null) {
        if (opObj instanceof OpTariffScheme) {
            this.copy(<OpTariffScheme>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #endregion


    // #region IJsonSerializable

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idTariff = opObj.IdTariff
            if (opObj.TariffOptionsData != null) {
                this.tariffOptionsData.push(...opObj.TariffOptionsData.map(data => new OpTariffData(data)))
            }
        } 
    }

    public toJSON(compressed: boolean = false): any {
        return {
            IdTariff: this.idTariff,
            TariffOptionsData: this.tariffOptionsData != null ? this.tariffOptionsData.ToJSON() : null
        }
    }

    // #endregion 


    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpTariffScheme {
        const scheme: OpTariffScheme = new OpTariffScheme()

        scheme.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return scheme
    }

    public copy(source: OpTariffScheme, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            // No Navigation Properties
        }

        if (includeCustomProperties) {
            // No Custom Properties
        }

        if (includeDataList) {
            // No DataList
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idTariff = source.idTariff

        if (source.tariffOptionsData != null) {
            source.tariffOptionsData.toArray().forEach((data: OpTariffData) => {
                this.tariffOptionsData.push(data.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues))
            })
        }

    }

    // #endregion 


}